
import { mapMutations, mapState } from 'vuex';

import Product from '@/components/shop/product.vue';
import LoadMore from '@/components/ui/loadMore.vue';
import EmptyState from '~/components/ui/emptyState.vue';
import { filterProducts } from '@/utils/filterProducts';

export default {
  name: 'MyFavorites',

  components: {
    Product,
    LoadMore,
    EmptyState,
  },

  layout: 'cat',

  data() {
    return {
      page: 1,
      lastPage: null,
      perPage: 12,
      loading: false,
      noProducts: false,
      myFavoritesIds: [],
    };
  },

  computed: {
    ...mapState(['myFavorites', 'user', 'products']),

    myProductsOnly() {
      return filterProducts(
        this.$store,
        this.products.filter((p) => this.myFavoritesIds.includes(p.sku))
      );
    },
  },

  watch: {
    myFavorites(newVal) {
      if (!newVal.length) {
        this.noProducts = true;
      } else {
        this.noProducts = false;
        this.getProducts();
      }
    },
  },

  async mounted() {
    if (this.user === null) {
      this.$router.push(this.localePath({ name: 'shop' }));
    }
    if (this.myFavorites.length) {
      await this.getProducts();
    } else {
      this.noProducts = true;
    }
  },

  methods: {
    ...mapMutations(['setProducts']),

    async getProducts() {
      this.myFavoritesIds = this.myFavorites.map((f) => f.sage_id);
      const { data, headers } = await this.$wc.products({
        perPage: this.perPage,
        page: this.page,
        sku: this.myFavoritesIds,
      });
      if (data && data.length) {
        this.setProducts(data);
        this.page++;
        if (headers['x-wp-totalpages']) {
          this.lastPage = parseInt(headers['x-wp-totalpages']);
        }
      }
    },
  },
};
